module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rintro1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0008#intro1"
    }
  }, [_vm._v("Introduction to the New Revised Edition: GO beyond GDP")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rintro2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0009#intro2"
    }
  }, [_vm._v("Introduction to the Previous Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rpref"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0010#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0011#ch01"
    }
  }, [_vm._v("1. Introduction: The Case for a New Macroeconomics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0012#pt01"
    }
  }, [_vm._v("PART 1")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0012#pt01"
    }
  }, [_vm._v("THE STRUCTURE OF PRODUCTION: A HISTORICAL SURVEY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0013#ch02"
    }
  }, [_vm._v("2. The Theory of Production in Classical Economics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0014#ch03"
    }
  }, [_vm._v("3. Hayek and the 1930s: A New Vision of Macroeconomics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0015#ch04"
    }
  }, [_vm._v("4. Time and Production in the Post-Keynesian Era")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0016#pt02"
    }
  }, [_vm._v("PART 2")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0016#pt02"
    }
  }, [_vm._v("THE THEORETICAL FRAMEWORK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0017#ch05"
    }
  }, [_vm._v("5. The Structure of Production: The Building Blocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0019#ch06"
    }
  }, [_vm._v("6. Time and the Aggregate Production Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0020#ch07"
    }
  }, [_vm._v("7. Savings, Technology, and Economic Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0021#ch08"
    }
  }, [_vm._v("8. The Theory of Commodity Money: Economics of a Pure Gold Standard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0022#ch09"
    }
  }, [_vm._v("9. Economics of a Fiat Money Standard: A Theory of the Business Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt03"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "px"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0023#pt03"
    }
  }, [_vm._v("PART 3")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0023#pt03"
    }
  }, [_vm._v("APPLICATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0024#ch10"
    }
  }, [_vm._v("10. Implications for Government Economic Policy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0025#ch11"
    }
  }, [_vm._v("11. Conclusions: The Future of Economic Theory and Research")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "rrefs"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0026#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0027#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "raubio"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0028#aubio"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a327802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nyu-skousen-0007.vue
// module id = 72
// module chunks = 0